import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3117f8e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-header" }
const _hoisted_2 = {
  key: 0,
  class: "pc-header-padding"
}
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "section" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "new-badge" }, "new", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingItem = _resolveComponent("SettingItem")!
  const _component_SwitchBox = _resolveComponent("SwitchBox")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page sub-page", { 'sl-full': _ctx.isFullScreen, 'android-padding': _ctx.isAndroid, 'ios-padding': _ctx.isIOS }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.envStore.isInPC)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        href: "javascript:;",
        class: "qh-icon-back",
        title: "返回",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
      }),
      _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_SettingItem, {
          class: "section-item update-entrance",
          "native-click": "",
          title: _ctx.$t.updateEntrance,
          clickid: "service_list",
          onClick: _ctx.gotoServiceListPage
        }, _createSlots({ _: 2 }, [
          (_ctx.hasNewVersion)
            ? {
                name: "extra",
                fn: _withCtx(() => [
                  _hoisted_5
                ])
              }
            : undefined
        ]), 1032, ["title", "onClick"]),
        _createVNode(_component_SwitchBox, {
          class: "section-item",
          checked: _ctx.isAutoUpgrade,
          onChange: _ctx.onAutoUpgradeToggle,
          title: _ctx.$t.autoUpdateTitle,
          subtitle: _ctx.$t.autoUpdageSubTitle
        }, null, 8, ["checked", "onChange", "title", "subtitle"])
      ])
    ])
  ], 2))
}